<script>
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'
import { patientService } from '@services/PatientService'
import { userService } from '@services/UserService'
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import Form from '@classes/Form'
import CustomSnackbar from '@components/custom-snackbar.vue'

export default {
  components: { VueTelInputVuetify, CustomSnackbar },
  data() {
    return {
      changeData: false,
      userData: null,
      valid: false,
      successMessage: false,
      imperialUnits: '',
      patientData: '',
      states: [],
      sex: [],
      gender: [],
      ethnicity: [],
      relationship: [],
      childrenNumber: ['None', 1, 2, 3, 4, 5, 6, 7, 8, 9, '10+'],
      maritalStatus: [],
      enableButton: false,
      EmergencyPhoneNumberError: '',
      primaryPhoneNumberError: '',
      isSecondaryInsurance: false,
      tmpSecondaryInsurance: null,
      patientForm: new Form({
        sex: '',
        gender: '',
        weight: '',
        feet: '',
        inches: '',
        meters: '',
        race: null,
        marital_status: null,
        no_children: '',
        occupation: null,
        insurance_data: {
          primary_health_plan_name: null,
          primary_plan_type: null,
          primary_group_number: null,
          primary_member_id: null,
          primary_plan_id: null,
          secondary_health_plan_name: null,
          secondary_plan_type: null,
          secondary_group_number: null,
          secondary_member_id: null,
          secondary_plan_id: null,
        },
        eme_contact_fname: '',
        eme_contact_lname: '',
        eme_contact_add: '',
        eme_contact_city: '',
        eme_contact_state: '',
        eme_contact_zip: '',
        eme_contact_phone_number: null,
        primary_care_fname: '',
        primary_care_lname: '',
        primary_care_speciality: '',
        primary_care_hospital: null,
        primary_care_phone_number: null,
        notes: null,
      }),
      notGreekRule: [
        (v) =>
          !v || !v.length > 0 || /^[a-zA-Z0-9, ]+$/g.test(v) || 'Invalid data',
      ],
      heightRule: [
        (v) =>
          !v || !v.length > 0 || /^[a-zA-Z0-9, ]+$/g.test(v) || 'Invalid data',
      ],
      weightInchRule: [
        (v) =>
          !v.length > 0 || /^[1-9]\d*(\.\d+)?$/.test(v) || 'Invalid format',
      ],
      onlyNumberRegex: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g.test(v) ||
          'Invalid data',
      ],
      onlyAlphabetRegex: [
        (v) => !v || !v.length > 0 || /^[a-zA-Z ]+$/g.test(v) || 'Invalid data',
      ],
      onlyAlphaNumberRegex: [
        (v) =>
          !v || !v.length > 0 || /^[a-zA-Z0-9]+$/g.test(v) || 'Invalid data',
      ],
      alphabetWithSpecialCharacterRegex: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /^[A-Za-z()-\s, ]+$/g.test(v) ||
          'Invalid data',
      ],
      zipRule: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /^\d{5}(-\d{4})?$/.test(v) ||
          'Invalid Zip Code,It should be in the format of 12345 or 12345-1234.',
      ],
      WeightLbsRule: [
        (v) =>
          !v || !v.length > 0 || /^\d{5}(-\d{4})?$/.test(v) || 'Invalid format',
      ],
      snackbar: false,
      snackbarMessage: '',
    }
  },

  computed: {
    ...authComputed,

    ...optionsComputed,
    disableBtn() {
      if (!this.valid) {
        return true
      }
      if (this.changeData) {
        return false
      } else if (
        this.patientForm.eme_contact_fname === '' ||
        this.patientForm.eme_contact_lname === '' ||
        this.patientForm.eme_contact_add === '' ||
        this.patientForm.eme_contact_city === '' ||
        this.patientForm.eme_contact_state === '' ||
        this.patientForm.eme_contact_zip === '' ||
        this.patientForm.eme_contact_phone_number === '' ||
        this.patientForm.primary_care_fname === '' ||
        this.patientForm.primary_care_lname === '' ||
        this.patientForm.primary_care_speciality === '' ||
        this.patientForm.primary_care_hospital === '' ||
        this.patientForm.primary_care_phone_number === '' ||
        this.patientForm.notes === '' ||
        this.patientForm.height === '' ||
        this.patientForm.weight === '' ||
        !this.changeData
      ) {
        return true
      } else {
        return null
      }
    },
  },

  watch: {
    userData(newValue) {},
  },

  async mounted() {
    this.userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.imperialUnits = this.userData.user.imperial_units
    this.userOrg = this.userData.user.user_org_details[0].org_name
    if (this.userOrg === 'safehaven') {
      this.show = true
    }
    try {
      const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
      this.userOrg = userData.user.user_org_details[0].org_name
      if (this.userOrg === 'safehaven') {
        this.show = true
      }
      this.updateUserInfo()
      // Get UserOptions
      const userOptions = (await userService.options()).data
      if (userOptions) {
      }

      // Get PatientOptions
      const patientOptions = (await patientService.options()).data
      if (patientOptions) {
        this.sex = patientOptions.sex
        this.gender = patientOptions.gender
        this.ethnicity = patientOptions.race
        this.maritalStatus = patientOptions.marital_status
        this.states = patientOptions.states
      }
      this.getPatientInfo()
    } catch (error) {
      console.warn(error)
    }
  },

  methods: {
    ...authMethods,
    async getPatientInfo() {
      var patientData = (
        await patientService.get(this.currentUser.user.roles.patient)
      ).data
      if (patientData) {
        this.patientData = patientData
        this.responseToFormObject(patientData, 'patient')
      }
    },
    updateImperialUniotData() {
      this.userData = JSON.parse(localStorage.getItem('auth.currentUser'))
      this.imperialUnits = this.userData.user.imperial_units
      this.updateUserInfo()
      this.getPatientInfo()
    },
    updateUserInfo() {
      this.patientForm.sex = this.currentUser.user.sex
    },
    checkSecondaryInsurance() {
      if (
        (this.patientForm.insurance_data.secondary_health_plan_name &&
          this.patientForm.insurance_data.secondary_health_plan_name.length >
            0) ||
        (this.patientForm.insurance_data.secondary_plan_type &&
          this.patientForm.insurance_data.secondary_plan_type.length > 0) ||
        (this.patientForm.insurance_data.secondary_group_number &&
          this.patientForm.insurance_data.secondary_group_number.length > 0) ||
        (this.patientForm.insurance_data.secondary_member_id &&
          this.patientForm.insurance_data.secondary_member_id.length > 0) ||
        (this.patientForm.insurance_data.secondary_plan_id &&
          this.patientForm.insurance_data.secondary_plan_id.length > 0)
      ) {
        this.isSecondaryInsurance = true
      } else {
        this.isSecondaryInsurance = false
      }
    },
    responseToFormObject(data, type) {
      if (data) {
        for (const field in data) {
          if (data[field]) {
            if (type === 'patient') {
              this.patientForm[field] = data[field]
            } else {
              this.professionalForm[field] = data[field]
            }
          }
        }

        this.patientForm.eme_contact_fname = data.emergency_contact_first_name
        this.patientForm.no_children =
          data.no_children === 0
            ? 'None'
            : data.no_children === 10
            ? '10+'
            : data.no_children
        this.patientForm.eme_contact_lname = data.emergency_contact_last_name
        this.patientForm.eme_contact_add = data.emergency_contact_address
        this.patientForm.eme_contact_city = data.emergency_city
        this.patientForm.eme_contact_state = data.emergency_state.key
          ? data.emergency_state
          : null
        this.patientForm.eme_contact_zip = data.emergency_zip_code
        this.patientForm.eme_contact_phone_number =
          data.emergency_contact_phone_number
        this.patientForm.primary_care_fname = data.personal_doctor_first_name
        this.patientForm.primary_care_lname = data.personal_doctor_last_name
        this.patientForm.primary_care_speciality =
          data.personal_doctor_specialty
        this.patientForm.primary_care_hospital = data.hospital
        this.patientForm.primary_care_phone_number =
          data.personal_doctor_phone_number
        this.patientForm.notes = data.notes === '' ? null : data.notes
        this.patientForm.height = data.height
        this.patientForm.weight = data.weight
        this.patientForm.insurance_data = {
          primary_health_plan_name:
            data.insurance_data.primary_health_plan_name,
          primary_plan_type: data.insurance_data.primary_plan_type,
          primary_group_number: data.insurance_data.primary_group_number,
          primary_member_id: data.insurance_data.primary_member_id,
          primary_plan_id: data.insurance_data.primary_plan_id,
          secondary_health_plan_name:
            data.insurance_data.secondary_health_plan_name,
          secondary_plan_type: data.insurance_data.secondary_plan_type,
          secondary_group_number: data.insurance_data.secondary_group_number,
          secondary_member_id: data.insurance_data.secondary_member_id,
          secondary_plan_id: data.insurance_data.secondary_plan_id,
        }
        // set weight/height
        if (type === 'patient') {
          this.weight =
            this.patientForm.weight !== null
              ? parseFloat(this.patientForm.weight).toFixed(1)
              : null
          this.patientForm.meters =
            this.patientForm.height !== null
              ? parseFloat(this.patientForm.height).toFixed(2)
              : null
          // switch to imperial if needed
          if (this.imperialUnits) {
            this.setInputsWeightHeight(true)
          }
        }
      }
      this.checkSecondaryInsurance()
    },
    setInputsWeightHeight(toImperial) {
      if (toImperial) {
        this.patientForm.weight =
          this.patientForm.weight !== null && this.patientForm.weight !== 0
            ? parseFloat(this.patientForm.weight * 2.20462).toFixed(1)
            : null
        this.patientForm.feet =
          this.patientForm.meters !== null
            ? parseInt(this.patientForm.meters / 0.3048)
            : null
        this.patientForm.inches =
          this.patientForm.meters !== null
            ? Math.round((this.patientForm.meters % 0.3048) / 0.0254)
            : null
      } else {
        this.patientForm.weight = parseFloat(
          this.patientForm.weight / 2.20462
        ).toFixed(1)
        this.patientForm.meters = parseFloat(
          this.patientForm.feet * 0.3048 + this.patientForm.inches * 0.0254
        ).toFixed(2)
      }
    },
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.responseToFormObject(this.patientData, 'patient')
    },
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z, ]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    isNotLetter(e) {
      // console.log(e)
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault()
    },
    isAlphaNumber(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z0-9]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    isAlphabetWithSpecialCharacter(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z()-\s, ]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    onlyInches(e, val) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      var charCode = e.which ? e.which : e.keyCode
      if (
        parseFloat(
          this.patientForm.feet +
            '.' +
            (val + e.key < 10 ? parseInt('0') + (val + e.key) : val + e.key)
        ) > 7.1
      ) {
        return e.preventDefault()
      }
      if (charCode === 46) {
        return e.preventDefault()
      }
      if (!/^[A-Za-z]+$/.test(char)) {
        if (val) {
          if (parseInt(val + e.key) < 12) {
            return true
          } else e.preventDefault()
        } else {
          return true
        }
      }
      // Match with regex
      else e.preventDefault()
    },
    onlyLBS(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode
      if (parseFloat(value + e.key) > 650) {
        return e.preventDefault()
      }
      if (value.length === 4 && value.indexOf('.') === -1 && charCode !== 46) {
        return e.preventDefault()
      }
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    onlyKG(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode

      if (parseFloat(value + e.key) > 300) {
        return e.preventDefault()
      }
      if (value.length === 3 && value.indexOf('.') === -1 && charCode !== 46) {
        return e.preventDefault()
      }
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    onlyHeightMeter(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode
      if (parseFloat(value ? value + e.key : e.key) > 2.4) {
        return e.preventDefault()
      }
      if (value.length === 1 && value.indexOf('.') === -1 && charCode !== 46) {
        return e.preventDefault()
      }
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    onlyHeightFeet(e, value) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      var charCode = e.which ? e.which : e.keyCode
      if (parseFloat(value ? value + e.key : e.key) > 7) {
        return e.preventDefault()
      }
      if (charCode === 46) {
        return e.preventDefault()
      }
      if (!/^[A-Za-z]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault()
    },
    isOnlydecimal(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },

    async tryToSavePatient() {
      this.tryingToSavePatient = true
      this.patientErrors = null
      this.patientMessage = ''

      // update form
      let weight
      if (this.imperialUnits) {
        if (this.patientForm.weight !== '') {
          weight = parseFloat(this.patientForm.weight / 2.20462).toFixed(2)
        } else {
          weight = null
        }
        this.patientForm.height = parseFloat(
          this.patientForm.feet * 0.3048 + this.patientForm.inches * 0.0254
        ).toFixed(3)
        if (this.patientForm.height === '0.000') {
          this.patientForm.height = null
        }
      } else {
        if (this.patientForm.weight !== '') {
          weight = parseFloat(this.patientForm.weight).toFixed(1)
        } else {
          weight = null
        }
        this.patientForm.height = parseFloat(this.patientForm.meters).toFixed(3)
      }
      try {
        const Obj = {
          patient_id: this.userData.user.roles.patient,
          user: this.userData.user.user_id,
          weight: parseFloat(weight),
          height: parseFloat(this.patientForm.height),
          race: this.patientForm.race,
          marital_status: this.patientForm.marital_status,
          no_children:
            this.patientForm.no_children !== 'None' &&
            this.patientForm.no_children !== ''
              ? this.patientForm.no_children === '10+'
                ? 10
                : this.patientForm.no_children
              : 0,
          occupation:
            this.patientForm.occupation === ''
              ? null
              : this.patientForm.occupation,
          phone_number: null,
          address: null,
          fathers_name: null,
          emergency_contact_last_name:
            this.patientForm.eme_contact_lname === ''
              ? null
              : this.patientForm.eme_contact_lname,
          emergency_contact_first_name:
            this.patientForm.eme_contact_fname === ''
              ? null
              : this.patientForm.eme_contact_fname,
          emergency_contact_phone_number:
            this.patientForm.eme_contact_phone_number === ''
              ? null
              : this.patientForm.eme_contact_phone_number,
          emergency_contact_address:
            this.patientForm.eme_contact_add === ''
              ? null
              : this.patientForm.eme_contact_add,
          personal_doctor_last_name:
            this.patientForm.primary_care_lname === ''
              ? null
              : this.patientForm.primary_care_lname,
          personal_doctor_first_name:
            this.patientForm.primary_care_fname === ''
              ? null
              : this.patientForm.primary_care_fname,
          personal_doctor_specialty:
            this.patientForm.primary_care_speciality === ''
              ? null
              : this.patientForm.primary_care_speciality,
          insurance_provider: null,
          hospital:
            this.patientForm.primary_care_hospital === ''
              ? null
              : this.patientForm.primary_care_hospital,
          emergency_notification: null,
          allergies: null,
          notes: this.patientForm.notes === '' ? null : this.patientForm.notes,
          emergency_zip_code: this.patientForm.eme_contact_zip,
          emergency_city: this.patientForm.eme_contact_city,
          emergency_state: this.patientForm.eme_contact_state
            ? this.patientForm.eme_contact_state.key
              ? this.patientForm.eme_contact_state
              : this.states.find(
                  (x) => x.key === this.patientForm.eme_contact_state
                )
            : { key: null, value: null },
          personal_doctor_phone_number:
            this.patientForm.primary_care_phone_number,
          imperial_units: this.userData.user.imperial_units,
          gender: this.patientForm.gender.key
            ? this.patientForm.gender
            : this.gender.find((x) => x.key === this.patientForm.gender),
          sex: this.patientForm.sex.key
            ? this.patientForm.sex
            : this.sex.find((x) => x.key === this.patientForm.sex),
          insurance_data: {
            primary_health_plan_name: this.patientForm.insurance_data
              .primary_health_plan_name
              ? this.patientForm.insurance_data.primary_health_plan_name
              : null,
            primary_plan_type: this.patientForm.insurance_data.primary_plan_type
              ? this.patientForm.insurance_data.primary_plan_type
              : null,
            primary_group_number: this.patientForm.insurance_data
              .primary_group_number
              ? this.patientForm.insurance_data.primary_group_number
              : null,
            primary_member_id: this.patientForm.insurance_data.primary_member_id
              ? this.patientForm.insurance_data.primary_member_id
              : null,
            primary_plan_id: this.patientForm.insurance_data.primary_plan_id
              ? this.patientForm.insurance_data.primary_plan_id
              : null,
            secondary_health_plan_name: this.patientForm.insurance_data
              .secondary_health_plan_name
              ? this.patientForm.insurance_data.secondary_health_plan_name
              : null,
            secondary_plan_type: this.patientForm.insurance_data
              .secondary_plan_type
              ? this.patientForm.insurance_data.secondary_plan_type
              : null,
            secondary_group_number: this.patientForm.insurance_data
              .secondary_group_number
              ? this.patientForm.insurance_data.secondary_group_number
              : null,
            secondary_member_id: this.patientForm.insurance_data
              .secondary_member_id
              ? this.patientForm.insurance_data.secondary_member_id
              : null,
            secondary_plan_id: this.patientForm.insurance_data.secondary_plan_id
              ? this.patientForm.insurance_data.secondary_plan_id
              : null,
          },
        }
        this.primaryPhoneNumberError = null
        this.EmergencyPhoneNumberError = null
        await patientService.update(this.currentUser.user.roles.patient, Obj)
        this.successMessage = true
        this.snackbarMessage = 'Saved Successfully'
        this.snackbar = true
        setTimeout(() => {
          this.snackbar = false
        }, 3000)
      } catch (error) {
        this.patientForm.onFail(error.response.data)
        const str = error.response.data

        this.patientErrors = error
        if (
          str.indexOf(
            "personal_doctor_phone_number': [ErrorDetail(string='"
          ) !== -1
        ) {
          this.primaryPhoneNumberError = str.substring(
            str.indexOf("string='") + 8,
            str.indexOf("code='") - 4
          )
        } else if (error.response.data.personal_doctor_phone_number) {
          this.primaryPhoneNumberError =
            error.response.data.personal_doctor_phone_number
        }

        if (
          str.indexOf(
            "emergency_contact_phone_number': [ErrorDetail(string='"
          ) !== -1
        ) {
          this.EmergencyPhoneNumberError = str.substring(
            str.indexOf("string='") + 8,
            str.indexOf("code='") - 4
          )
        } else if (error.response.data.emergency_contact_phone_number) {
          this.EmergencyPhoneNumberError =
            error.response.data.emergency_contact_phone_number
        }
      }

      this.tryingToSavePatient = false

      this.getPatientInfo()
    },
    onChangeInput() {
      this.changeData = true
      this.successMessage = null
      this.phoneNumberError = null
    },
    showSecondaryInsurance(newStatus) {
      if (!newStatus) {
        this.tmpSecondaryInsurance = {
          secondary_health_plan_name:
            this.patientForm.insurance_data.secondary_health_plan_name,
          secondary_plan_type:
            this.patientForm.insurance_data.secondary_plan_type,
          secondary_group_number:
            this.patientForm.insurance_data.secondary_group_number,
          secondary_member_id:
            this.patientForm.insurance_data.secondary_member_id,
          secondary_plan_id: this.patientForm.insurance_data.secondary_plan_id,
        }
        this.patientForm.insurance_data.secondary_health_plan_name = null
        this.patientForm.insurance_data.secondary_plan_type = null
        this.patientForm.insurance_data.secondary_group_number = null
        this.patientForm.insurance_data.secondary_member_id = null
        this.patientForm.insurance_data.secondary_plan_id = null
        this.onChangeInput()
      } else if (newStatus && this.tmpSecondaryInsurance) {
        this.patientForm.insurance_data.secondary_health_plan_name =
          this.tmpSecondaryInsurance.secondary_health_plan_name
        this.patientForm.insurance_data.secondary_plan_type =
          this.tmpSecondaryInsurance.secondary_plan_type
        this.patientForm.insurance_data.secondary_group_number =
          this.tmpSecondaryInsurance.secondary_group_number
        this.patientForm.insurance_data.secondary_member_id =
          this.tmpSecondaryInsurance.secondary_member_id
        this.patientForm.insurance_data.secondary_plan_id =
          this.tmpSecondaryInsurance.secondary_plan_id
      }

      this.isSecondaryInsurance = newStatus
    },
  },
}
</script>

<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    :class="$style.form"
    @submit.prevent="validate"
  >
    <button
      id="updateImperialUnitButton"
      hidden
      @click="updateImperialUniotData"
    ></button>
    <v-container :class="$vuetify.breakpoint.mdAndDown ? $style.col : ''">
      <v-row class="mt-1">
        <v-col cols="6" md="6" sm="6" xs="6" class="py-0">
          <label> Sex</label>
          <v-select
            v-model="patientForm.sex"
            :items="sex"
            item-text="value"
            item-value="key"
            outlined
            required
            @change="onChangeInput"
          ></v-select>
        </v-col>

        <v-col cols="6" md="6" sm="6" xs="6" class="py-0">
          <label> Gender Identity</label>
          <v-select
            v-model="patientForm.gender"
            :items="gender"
            item-text="value"
            item-value="key"
            outlined
            required
            @change="onChangeInput"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="imperialUnits">
        <v-col cols="6" md="6" sm="6" xs="6" class="py-0">
          <label> Weight</label>
          <v-text-field
            v-model="patientForm.weight"
            outlined
            suffix="lbs"
            hint="less than 650"
            :maxlength="7"
            @paste.prevent
            @keydown="onChangeInput"
            @keypress="onlyLBS($event, patientForm.weight, 6)"
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3" sm="3" xs="3" class="py-0">
          <label> Height</label>
          <v-text-field
            v-model="patientForm.feet"
            hint="7 ft 10 inches"
            outlined
            :maxlength="2"
            suffix="ft"
            @paste.prevent
            @keypress="onlyHeightFeet($event, patientForm.feet)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3" sm="3" xs="3" class="py-0">
          <label>&nbsp;</label>
          <v-text-field
            v-model="patientForm.inches"
            outlined
            suffix="In"
            :maxlength="2"
            :rules="notGreekRule"
            @paste.prevent
            @keypress="onlyInches($event, patientForm.inches)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="6" md="6" class="py-0">
          <label> Weight</label>
          <v-text-field
            v-model="patientForm.weight"
            hint="less than 300"
            outlined
            suffix="kgs"
            :maxlength="6"
            @paste.prevent
            @keypress="onlyKG($event, patientForm.weight, 5)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" class="py-0">
          <label> Height</label>
          <v-text-field
            v-model="patientForm.meters"
            hint="less than 2.4"
            outlined
            :maxlength="4"
            suffix="m"
            @paste.prevent
            @keypress="onlyHeightMeter($event, patientForm.meters, 3)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <label> Race/ethnicity </label>
          <v-select
            v-model="patientForm.race"
            :items="ethnicity"
            item-text="value"
            item-value="key"
            outlined
            @change="onChangeInput"
          ></v-select>
        </v-col>
        <v-col cols="6" md="6" sm="6" xs="6" class="py-0">
          <label> Marital Status</label>
          <v-select
            v-model="patientForm.marital_status"
            :items="maritalStatus"
            item-text="value"
            item-value="key"
            outlined
            @change="onChangeInput"
          ></v-select>
        </v-col>
        <v-col cols="6" md="6" sm="6" xs="6" class="py-0">
          <label># of Children</label>
          <v-select
            v-model="patientForm.no_children"
            :items="childrenNumber"
            outlined
            @change="onChangeInput"
          ></v-select>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Occupation</label>
          <v-text-field
            v-model="patientForm.occupation"
            :maxlength="30"
            outlined
            :rules="notGreekRule"
            @keydown="onChangeInput"
            @keypress="isLetter($event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="pb-0"
          ><p :class="$style.formSectionHeading"
            >Primary Health Insurance</p
          ></v-col
        >
        <v-col cols="12" md="12" class="py-0">
          <label> Name of Health Plan</label>
          <v-text-field
            v-model="patientForm.insurance_data.primary_health_plan_name"
            :maxlength="30"
            outlined
            :rules="onlyAlphabetRegex"
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Plan of Type</label>
          <v-text-field
            v-model="patientForm.insurance_data.primary_plan_type"
            :maxlength="30"
            outlined
            :rules="alphabetWithSpecialCharacterRegex"
            @keypress="isAlphabetWithSpecialCharacter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Group Number</label>
          <v-text-field
            v-model="patientForm.insurance_data.primary_group_number"
            :maxlength="30"
            outlined
            :rules="onlyAlphaNumberRegex"
            @keypress="isAlphaNumber($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Member ID</label>
          <v-text-field
            v-model="patientForm.insurance_data.primary_member_id"
            :maxlength="30"
            outlined
            :rules="onlyAlphaNumberRegex"
            @keypress="isAlphaNumber($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Plan ID</label>
          <v-text-field
            v-model="patientForm.insurance_data.primary_plan_id"
            :maxlength="30"
            outlined
            :rules="onlyAlphaNumberRegex"
            @keypress="isAlphaNumber($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0"
          ><p :class="$style.borderClss">&nbsp;</p></v-col
        >
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="pb-0"
          ><p :class="$style.formSectionHeading">Emergency Contact</p></v-col
        >
        <v-col cols="12" md="12" class="py-0">
          <label> First Name</label>
          <v-text-field
            v-model="patientForm.eme_contact_fname"
            :maxlength="30"
            outlined
            :rules="notGreekRule"
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Last Name </label>
          <v-text-field
            v-model="patientForm.eme_contact_lname"
            :maxlength="30"
            outlined
            :rules="notGreekRule"
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label>Street Address </label>
          <v-text-field
            v-model="patientForm.eme_contact_add"
            :maxlength="100"
            outlined
            :rules="notGreekRule"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> City </label>
          <v-text-field
            v-model="patientForm.eme_contact_city"
            :maxlength="30"
            outlined
            :rules="notGreekRule"
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="9" md="9" sm="9" xs="9" class="py-0">
          <label> State </label>
          <v-select
            v-model="patientForm.eme_contact_state"
            :items="states"
            item-text="value"
            item-value="key"
            outlined
            @change="onChangeInput"
          ></v-select>
        </v-col>
        <v-col cols="3" md="3" sm="3" xs="3" class="py-0">
          <label> ZIP </label>
          <v-text-field
            v-model="patientForm.eme_contact_zip"
            :rules="zipRule"
            placeholder="12345"
            outlined
            required
            @keypress="isNotLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Phone number</label>
          <VueTelInputVuetify
            v-model="patientForm.eme_contact_phone_number"
            label=""
            :max-len="15"
            placeholder="555-555-5555"
            :rules="onlyNumberRegex"
            :only-countries="['US']"
            default-country="US"
            mode="international"
            outlined
            :error-messages="EmergencyPhoneNumberError"
            @keydown="
              onChangeInput(),
                isNotLetter($event),
                (EmergencyPhoneNumberError = null)
            "
          ></VueTelInputVuetify>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0"
          ><p :class="$style.borderClss">&nbsp;</p></v-col
        >
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="pb-0"
          ><p :class="$style.formSectionHeading"
            >Primary Care Physician</p
          ></v-col
        >
        <v-col cols="12" md="12" class="py-0">
          <label> First Name</label>
          <v-text-field
            v-model="patientForm.primary_care_fname"
            :maxlength="30"
            outlined
            required
            :rules="notGreekRule"
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Last Name </label>
          <v-text-field
            v-model="patientForm.primary_care_lname"
            :maxlength="30"
            outlined
            required
            :rules="notGreekRule"
            @keypress="isLetter($event)"
            @keydown="onChangeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label>Speciality</label>
          <v-text-field
            v-model="patientForm.primary_care_speciality"
            outlined
            :maxlength="50"
            required
            :rules="notGreekRule"
            @keydown="onChangeInput"
            @keypress="isLetter($event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Hospital </label>
          <v-text-field
            v-model="patientForm.primary_care_hospital"
            outlined
            :maxlength="100"
            required
            :rules="notGreekRule"
            @keydown="onChangeInput"
            @keypress="isLetter($event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0">
          <label> Phone number</label>
          <VueTelInputVuetify
            v-model="patientForm.primary_care_phone_number"
            :max-len="15"
            placeholder="555-555-5555"
            :rules="onlyNumberRegex"
            :only-countries="['US']"
            default-country="US"
            mode="international"
            label=""
            outlined
            :error-messages="primaryPhoneNumberError"
            @keydown="
              onChangeInput(),
                isNotLetter($event),
                (primaryPhoneNumberError = null)
            "
          ></VueTelInputVuetify>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0"
          ><p :class="$style.borderClss">&nbsp;</p></v-col
        >
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <label> Notes </label>
          <v-textarea
            v-model="patientForm.notes"
            :rules="notGreekRule"
            :maxlength="200"
            outlined
            @keydown="onChangeInput"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            depressed
            :class="[
              'primary-btn',
              disableBtn && 'disabled-btn',
              $vuetify.breakpoint.mobile && 'full-width-btn',
            ]"
            @click.prevent="tryToSavePatient"
          >
            Save
          </v-btn>
          <v-btn depressed :class="$style.cancelbtn" @click="reset">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
      <div>
        <CustomSnackbar
          :snackbar="snackbar"
          :snackbar-message="snackbarMessage"
        />
      </div>
    </v-container>
  </v-form>
</template>

<style lang="scss" module>
@import '@design';

.mandatory {
  color: #da1414;
}
.form label {
  display: inline-block;
  margin-bottom: 5px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #454648;
  letter-spacing: 0.2px;
}
.successMessage {
  font-size: 14px;
  font-weight: bold;
}
.borderClss {
  margin-top: 24px;
  margin-bottom: 0 !important;
  border-top: 1px solid #d1dfeb;
}
.radioClss {
  padding-left: 20px;
}
.formSectionHeading {
  margin-bottom: 4px !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.1px;
}
.radioClss label {
  margin-bottom: 0 !important;
  font-size: 14px !important;
  font-weight: normal !important;
}
.savebtn {
  width: 120px;
  height: 45px !important;
  margin-right: 20px;
  font-size: 14px !important;
  text-transform: capitalize;
  border-radius: 30px !important;
}
.cancelbtn {
  width: 120px;
  height: 45px !important;
  font-size: 14px !important;
  text-transform: capitalize;
  background-color: transparent !important;
  border-radius: 30px !important;
}

.addAndRemoveSecondaryInsuranceBtn {
  color: #0476d9 !important;
  cursor: pointer;
}
@media screen and (max-width: 959px) {
  .form label {
    font-size: 11px;
  }
}
@media screen and (max-width: 599px) {
  .savebtn,
  .cancelbtn {
    width: 100%;
    margin-bottom: 15px;
  }
}
.col {
  padding-top: 0 !important;
}
@media screen and (max-width: 400px) {
  .form label {
    font-size: 10px;
  }
}
</style>

<style scoped>
/deep/ .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #fff;
}
/deep/ .v-input--radio-group--row .v-input--radio-group__input > .v-label {
  padding-right: 22px;
}
/deep/ .v-text-field--outlined fieldset {
  border-color: #c4c4c4;
}
/deep/ .v-text-field--outlined.error--text fieldset {
  border-color: #ca024f;
}

/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background-color: #93c0e8 !important;
}

/deep/ .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0;
}

/deep/.theme--light.v-select .v-select__selections {
  font-size: 14px;
}
</style>
